import styles from './accordion.module.scss';
import {
  memo,
  useEffect,
  useState
} from "react";
import { AccordionItem } from "./accordionItem/accordionItem";

type AccordionProps = {
  data: Array<AccordionItemData>;
  customClick?: boolean;
  activeClassName?: string;
  onChangeActive?: (dataIndex?: number) => void;
  activeIndex?: number;
  maxHeight?: number;
  disabledAutoScroll?: boolean;
}

type AccordionItemData = {
  title: JSX.Element;
  child: JSX.Element;
  disabled?: boolean;
}

export const Accordion = memo(({ data, customClick, activeClassName, onChangeActive, activeIndex, maxHeight, disabledAutoScroll }: AccordionProps) => {
  const [localActiveIndex, setLocalActiveIndex] = useState<number>();

  useEffect(() => {
    setLocalActiveIndex((localActiveIndex) => activeIndex !== localActiveIndex ? activeIndex : localActiveIndex);
  }, [activeIndex]);

  const handleItemClick = (index: number, disabled?: boolean) => {
    if (!disabled) {
      if (localActiveIndex === index) {
        setLocalActiveIndex(undefined);
        !!onChangeActive && onChangeActive();
      } else {
        setLocalActiveIndex(index);
        !!onChangeActive && onChangeActive(index);
      }
    }
  };

  return (
    <div className={styles.container}>
      {data.map((item, index) => (
        <AccordionItem
          maxHeight={maxHeight}
          key={index}
          title={item.title}
          child={item.child}
          activeClassName={activeClassName}
          customClick={customClick}
          isOpen={localActiveIndex === index}
          disabledAutoScroll={disabledAutoScroll}
          onClick={() => handleItemClick(index, item.disabled)}
        />
      ))}
    </div>
  )
})
